module.exports = __webpack_public_path__ + "static/media/cover.38644759.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Cover/assets/cover.jpg
// module id = 82
// module chunks = 0